// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ReservationsInBatch\ReservationsInBatchViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { RecurringBatch, RecurringBatchData, RecurringBatchOptions } from 'data/models/RecurringBatch';
import { ReservationsDashboardRow, ReservationsDashboardRowData, ReservationsDashboardRowOptions } from 'data/models/ReservationsDashboardRow';

// ReservationsInBatchData is the class that ReservationsInBatch serializes to/from
export interface ReservationsInBatchData {
    BatchId : number;
    FromDate : /* ISO8601 */ string;
    ToDate : /* ISO8601 */ string;
	
    Batch : RecurringBatchData | null;
    Organization : OrganizationData | null;
    OrganizationId : number;
    Rows : ReservationsDashboardRowData[] | null;
	
    CanDelete : boolean;
}

// ReservationsInBatchOptions is the class which may be passed to the ReservationsInBatch constructor to define optional initial data values
export interface ReservationsInBatchOptions {
    BatchId : number;
    FromDate : /* ISO8601 */ string;
    ToDate : /* ISO8601 */ string;
	
    Batch? : RecurringBatchOptions | null;
    Organization? : OrganizationOptions | null;
    OrganizationId? : number;
    Rows? : ReservationsDashboardRowOptions[] | null;
	
    CanDelete? : boolean;
}

export class ReservationsInBatch {
    public BatchId : DataSignal<number>;
    public FromDate : DataSignal<TZDate>;
    public ToDate : DataSignal<TZDate>;
	
    public Batch : DataSignal<RecurringBatch | null>;
    public Organization : DataSignal<Organization | null>;
    public OrganizationId : DataSignal<number>;
    public Rows : SDataArray<ReservationsDashboardRow>;
	
    public CanDelete : DataSignal<boolean>;

    constructor();
    constructor(data : ReservationsInBatchOptions);
    constructor(data: ReservationsInBatchOptions | null = null) {
        this.BatchId = jsonableObservable(S.value<number>(data && data.BatchId !== undefined ? data.BatchId : 0));
        this.FromDate = jsonableObservable(S.value<TZDate>(data && data.FromDate !== undefined ? new TZDate(data.FromDate) : new TZDate(0), TZDate.eq));
        this.ToDate = jsonableObservable(S.value<TZDate>(data && data.ToDate !== undefined ? new TZDate(data.ToDate) : new TZDate(0), TZDate.eq));
	    
        this.Batch = S.value<RecurringBatch | null>(null);
        this.Organization = S.value<Organization | null>(null);
        this.OrganizationId = jsonableObservable(S.value<number>(data && data.OrganizationId !== undefined ? data.OrganizationId : 0));
        this.Rows = SArray<ReservationsDashboardRow>([]);
	    
        this.CanDelete = jsonableObservable(S.value<boolean>(data && data.CanDelete !== undefined ? data.CanDelete : false));
    }

    static key(obj : ReservationsInBatch) {
        return obj.BatchId() + '\u2618' + obj.FromDate().toJSON() + '\u2618' + obj.ToDate().toJSON();
    }
    
    static dataKey(obj : ReservationsInBatchOptions) {
        return obj.BatchId + '\u2618' + new TZDate(obj.FromDate).toJSON() + '\u2618' + new TZDate(obj.ToDate).toJSON();
    }

    static update(obj : ReservationsInBatch, data : ReservationsInBatchOptions) {
        S.freeze(() => {
            if (data.BatchId !== undefined) obj.BatchId(data.BatchId);
            if (data.FromDate !== undefined) obj.FromDate(new TZDate(data.FromDate));
            if (data.ToDate !== undefined) obj.ToDate(new TZDate(data.ToDate));
	        
            if (data.OrganizationId !== undefined) obj.OrganizationId(data.OrganizationId);
	        
            if (data.CanDelete !== undefined) obj.CanDelete(data.CanDelete);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/ReservationsInBatch.ts